import React from 'react';
import {styleForHeader} from '../../style.js';

export const GridColumns = [
    { field: 'id', hide: true},
    { field: 'user', width: 250, headerAlign:'center', align:'center', type:'singleSelect', labelText:'Kullanıcı Adı', text:'KULLANICI ADI',
        renderHeader: () => styleForHeader('KULLANICI ADI'),
        renderCell: (params) => (<div>{params.value.fullName}</div>),
        dataList:[],
        keyField:'id',valueField:'fullName'             
    },    
    { field: 'role', width: 250, headerAlign: 'center', align:'center', type:'singleSelect', labelText:'Rol Adı', text:'ROL ADI',
      renderHeader: () => styleForHeader('ROL ADI'),   
      renderCell: (params) => (<div>{params.value.name}</div>),
      dataList:[],
      keyField:'id',valueField:'name'
    }
];